module.exports = __webpack_public_path__ + "static/media/stock-trainer.145bbd67.png";